(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["malvice-pair-well"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('malvice-pair-well-list')) {
    customElements.define(
      'malvice-pair-well-list',
      class MalvicePairWellList extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.handleVariantChange);
          this.addEventListener('scroll', this.updateScrollButtons, { passive: true });
          this.parentElement.querySelectorAll('[data-pair-scroll]').forEach((button) => {
            button.addEventListener('click', this.handleScroll);
          });
          this.updateScrollButtons();
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.handleVariantChange);
          this.removeEventListener('scroll', this.updateScrollButtons);
          this.parentElement.querySelectorAll('[data-pair-scroll]').forEach((button) => {
            button.removeEventListener('click', this.handleScroll);
          });
        }

        handleScroll(event) {
          const list = event.currentTarget.closest('.malvice-pair-well')?.querySelector('malvice-pair-well-list');
          const item = list?.querySelector('.malvice-pair-well__item');
          if (!list || !item) return;
          const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          list.scrollBy({
            left: Number(event.currentTarget.dataset.pairScroll) * (item.getBoundingClientRect().width + gap),
            behavior: 'smooth',
          });
        }

        updateScrollButtons() {
          const buttons = this.parentElement.querySelectorAll('[data-pair-scroll]');
          buttons.forEach((button) => {
            button.disabled = button.dataset.pairScroll === '-1'
              ? this.scrollLeft <= 1
              : this.scrollLeft + this.clientWidth >= this.scrollWidth - 2;
          });
        }

        handleVariantChange(event) {
          const select = event.target.closest('[data-pair-variant]');
          if (!select) return;

          const row = select.closest('[data-pair-row]');
          const option = select.selectedOptions[0];
          if (!row || !option) return;

          const price = row.querySelector('[data-pair-price]');
          const compareAt = row.querySelector('[data-pair-compare]');
          const saving = row.querySelector('[data-pair-saving]');
          const button = row.querySelector('[ref="addToCartButton"]');
          const image = row.querySelector('.malvice-pair-well__image');
          const addToCart = row.querySelector('add-to-cart-component');
          const onSale = option.dataset.onSale === 'true';

          if (price) price.textContent = option.dataset.price || '';
          if (compareAt) {
            compareAt.textContent = option.dataset.compareAt || '';
            compareAt.hidden = !onSale;
          }
          if (saving) {
            saving.textContent = option.dataset.saving || '';
            saving.hidden = !onSale;
          }
          if (button) button.disabled = option.dataset.available !== 'true';
          if (image && option.dataset.image) {
            image.src = option.dataset.image;
            image.srcset = option.dataset.image;
          }
          if (addToCart && option.dataset.image) {
            addToCart.dataset.productVariantMedia = option.dataset.image;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["malvice-product-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('malvice-region-shipping')) {
    let detectedCountry;
    const getDetectedCountry = () => {
      if (!detectedCountry) {
        const root = window.Shopify?.routes?.root || '/';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 4000);
        detectedCountry = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
          credentials: 'same-origin',
          signal: controller.signal
        }).then(response => response.ok ? response.json() : null)
          .then(data => data?.detected_values?.country || null)
          .catch(() => null)
          .finally(() => clearTimeout(timeout));
      }
      return detectedCountry;
    };
    customElements.define('malvice-region-shipping', class extends HTMLElement {
      connectedCallback() {
        this.handleVisibility ||= () => document.hidden ? this.stopClock() : this.startClock();
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.startClock();
        getDetectedCountry().then(country => {
          if (!this.isConnected || typeof country?.name !== 'string' || !country.name.trim() || !/^[A-Z]{2}$/.test(country.handle)) return;
          const label = this.querySelector('[data-region-label]');
          if (!label || !this.dataset.labelTemplate) return;
          this.dataset.countryCode = country.handle;
          this.dataset.countryName = country.name;
          label.textContent = this.dataset.labelTemplate.replace('[region]', country.name);
        });
      }
      disconnectedCallback() {
        this.stopClock();
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }
      startClock() {
        this.stopClock();
        if (document.hidden || !this.querySelector('[data-clock]')) return;
        try {
          this.clockFormatter ||= new Intl.DateTimeFormat('en-GB', {
            timeZone: this.dataset.timeZone || 'Africa/Algiers',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
          });
        } catch {
          return;
        }
        this.updateClock();
        this.clockInterval = window.setInterval(() => this.updateClock(), 1000);
      }
      stopClock() {
        window.clearInterval(this.clockInterval);
        this.clockInterval = null;
      }
      updateClock() {
        const parts = this.clockFormatter.formatToParts(new Date());
        const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
        const remaining = 86400 - (Number(values.hour) * 3600 + Number(values.minute) * 60 + Number(values.second));
        const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
        const minutes = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        const clock = this.querySelector('[data-clock]');
        this.querySelector('[data-hours]').textContent = hours;
        this.querySelector('[data-minutes]').textContent = minutes;
        this.querySelector('[data-seconds]').textContent = seconds;
        if (this.dataset.timerTemplate) clock.setAttribute('aria-label', this.dataset.timerTemplate.replace('[hours]', hours).replace('[minutes]', minutes).replace('[seconds]', seconds));
        clock.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["malvice-product-guide"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.hasAttribute('data-malvice-size-guide-ready')) {
    document.documentElement.setAttribute('data-malvice-size-guide-ready', '');
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var opener = event.target.closest('[data-malvice-size-chart-open]');
      if (opener) {
        var sizeDialog = document.getElementById(opener.getAttribute('data-malvice-size-chart-open'));
        if (sizeDialog && typeof sizeDialog.showModal === 'function') sizeDialog.showModal();
        return;
      }
      if (event.target.matches('.malvice-size-guide-dialog[open]')) event.target.close();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
